// extracted by mini-css-extract-plugin
module.exports = {"container":"indicator_container__3XVKm"};